import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import AccountCircleTwoToneIcon from '@mui/icons-material/AccountCircleTwoTone';
import EmailTwoToneIcon from '@mui/icons-material/EmailTwoTone';
import CallTwoToneIcon from '@mui/icons-material/CallTwoTone';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import './Updateprofile.css'
import Swal from 'sweetalert2'
import { getUserApi, updateProfileApi } from '../components/ApiService';
import { useNavigate } from 'react-router-dom';

const UpdateProfile = () => {
    const [userDetails, setUserDetails] = useState([])
    const [token, setToken] = useState('')
    const [firstName, setfirstName] = useState('')
    const [lastName, setlastName] = useState('')
    const [email, setEmail] = useState('')
    const [contact, setcontact] = useState('')

    const navigate = useNavigate()

    useEffect(() => {
        // GET USER DETAILS
        const dtl = localStorage.getItem("user")
        if (dtl) {
            const parsedUser = JSON.parse(dtl)
            // setuserDtl(parsedUser)
            console.log(parsedUser.token, "UPDATE-PROFILE TOKEN")
            setToken(parsedUser.token)

            getUserApi(parsedUser.token).then((res) => {
                setUserDetails(res.data)
                setfirstName(res.data?.user?.firstName)
                setlastName(res.data?.user?.lastName)
                setEmail(res.data?.user?.emailAddress)
                setcontact(res.data?.user?.phoneNumber)
                console.log(res.data, "RESPONSE USER DETAILS")
            }).catch((error) => {
                const Toast = Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.onmouseenter = Swal.stopTimer;
                        toast.onmouseleave = Swal.resumeTimer;
                    }
                });
                Toast.fire({
                    icon: "error",
                    title: error.response.data.message
                });
            })
        }
    }, [])

    const getFirstName = (e) => {
        setfirstName(e.target.value)
    }

    const getLastName = (e) => {
        setlastName(e.target.value)
    }

    const getEmailAdd = (e) => {
        setEmail(e.target.value)
    }

    const getContactNum = (e) => {        
        setcontact(e.target.value)
    }

    const update = () => {
        const emailRegex = /^[^@]+@[^@]+\.[^@]+$/
        const contactRegex = /((\+*)((0[ -]*)*|((91 )*))((\d{12})+|(\d{10})+))|\d{5}([- ]*)\d{6}/

        const obj = {
            "firstName": firstName,
            "lastName": lastName,
            "emailAddress": email,
            "phoneCountryCode": "+91",
            "phoneNumber": contact
        }

        if (firstName.length == 0) {
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: 'First Name is Mandatory!'
            });
        } else if (lastName.length == 0) {
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: 'Last Name is Mandatory!'
            });
        } else if (email.length == 0 || !emailRegex.test(email)) {
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: 'Enter Valid Email Address!'
            });
        } if (contact.length == 0 || !contactRegex.test(contact)) {
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: 'Enter Valid Contact Number!'
            });
        } else {
            updateProfileApi(obj, token).then((res) => {
                console.log(res, "UPDATE PROFILE")
                const Toast = Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.onmouseenter = Swal.stopTimer;
                        toast.onmouseleave = Swal.resumeTimer;
                    }
                });
                Toast.fire({
                    icon: "success",
                    title: res.data.message
                });
                navigate('/')
            })
        }
    }

    return (
        <>
            <section className='updt_cont'>
                <div className='container'>
                    <div className='centerBox'>
                        <Box
                            sx={{
                                display: 'flex',
                                flexWrap: 'wrap'
                            }}
                        >
                            <Paper elevation={3} style={{ padding: '50px' }} >
                                <h1> Update Profile </h1>

                                {/* USER TYPE */}
                                <FormControl fullWidth style={{ marginBottom: '15px' }}>
                                    <TextField
                                        id="outlined-basic4"
                                        label="User Type"
                                        variant="outlined"
                                        disabled
                                        defaultValue={userDetails?.user?.role?.roleName}
                                        slotProps={{
                                            input: {
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <AccountCircleTwoToneIcon />
                                                    </InputAdornment>
                                                ),
                                            },
                                        }}
                                    />
                                </FormControl>

                                {/* FIRST NAME */}
                                <FormControl fullWidth style={{ marginBottom: '15px' }}>
                                    <TextField
                                        id="outlined-basic1"
                                        label="First Name"
                                        variant="outlined"
                                        value={firstName}
                                        required
                                        onChange={getFirstName}
                                        slotProps={{
                                            input: {
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <AccountCircleTwoToneIcon />
                                                    </InputAdornment>
                                                ),
                                            },
                                        }}
                                    />
                                </FormControl>

                                {/* LAST NAME */}
                                <FormControl fullWidth style={{ marginBottom: '15px' }}>
                                    <TextField
                                        id="outlined-basic2"
                                        label="Last Name"
                                        variant="outlined"
                                        required
                                        value={lastName}
                                        onChange={getLastName}
                                        slotProps={{
                                            input: {
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <AccountCircleTwoToneIcon />
                                                    </InputAdornment>
                                                ),
                                            },
                                        }}
                                    />
                                </FormControl>

                                {/* EMAIL */}
                                <FormControl fullWidth style={{ marginBottom: '15px' }}>
                                    <TextField
                                        id="outlined-basic3"
                                        type='email'
                                        label="Email"
                                        variant="outlined"
                                        required
                                        value={email}
                                        onChange={getEmailAdd}
                                        slotProps={{
                                            input: {
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <EmailTwoToneIcon />
                                                    </InputAdornment>
                                                ),
                                            },
                                        }}
                                    />
                                </FormControl>

                                {/* CONTACT */}
                                <FormControl fullWidth style={{ marginBottom: '15px' }}>
                                    <TextField
                                        id="outlined-basic3"
                                        type='tel'
                                        label="Contact Number"
                                        variant="outlined"
                                        required
                                        value={contact}
                                        onChange={getContactNum}
                                        slotProps={{
                                            input: {
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <CallTwoToneIcon />
                                                    </InputAdornment>
                                                ),
                                            },
                                        }}
                                    />
                                </FormControl>

                                <Button variant="contained" fullWidth endIcon={<SendIcon />} onClick={update}> Update Profile </Button>
                            </Paper>
                        </Box>
                    </div>

                </div>
            </section >
        </>
    )
}

export default UpdateProfile